<template>
	<!-- Benefits Start -->
    <footer :class="footerClass">
		<div class="container-fluid">
			<div class="benefits">
				<div class="row justify-content-center  benefits-wrapper">
					<div class="col-xxl-10 col-xl-12">
						<div class="row row-gap-3">
							<div class="col-xl-2 col-md-4 col-6">
								<div class="benefit-block">
									<div class="image-box mb-12">
										<img src="/assets/media/icons/icon-1-sm.png" alt="">
									</div>
									<div class="content-box">
										<p class="fw-500 mb-4p">Легкий Возврат</p>
									</div>
								</div>
							</div>
							<div class="col-xl-2 col-md-4 col-6">
								<div class="benefit-block">
									<div class="image-box mb-12">
										<img src="/assets/media/icons/icon-2-sm.png" alt=""> 
									</div>
									<div class="content-box">
										<p class="fw-500 mb-4p">Быстрая Доставка</p>
									</div>
								</div>
							</div>
							<div class="col-xl-2 col-md-4 col-6">
								<div class="benefit-block">
									<div class="image-box mb-12">
										<img src="/assets/media/icons/icon-3-sm.png" alt="">
									</div>
									<div class="content-box">
										<p class="fw-500 mb-4p">Безопасная Оплата</p>
									</div>
								</div>
							</div>
							<div class="col-xl-2 col-md-4 col-6">
								<div class="benefit-block">
									<div class="image-box mb-12">
										<img src="/assets/media/icons/icon-4-sm.png" alt=""> 
									</div>
									<div class="content-box">
										<p class="fw-500 mb-4p">Большие Скидки</p>
									</div>
								</div>
							</div>
							<div class="col-xl-2 col-md-4 col-6">
								<div class="benefit-block">
									<div class="image-box mb-12">
										<img src="/assets/media/icons/icon-6-sm.png" alt=""> 
									</div>
									<div class="content-box">
										<p class="fw-500 mb-4p">Качественные Товары</p>
									</div>
								</div>
							</div>
							<div class="col-xl-2 col-md-4 col-6">
								<div class="benefit-block">
									<div class="image-box mb-12">
										<img src="/assets/media/icons/icon-5-sm.png" alt=""> 
									</div>
									<div class="content-box">
										<p class="fw-500 mb-4p">Поддержка 24/7</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="hr-line"></div>
			<div class="footer-wrapper pt-40 mb-32">
				<div class="store-desc">
					<router-link :to="{path: '/'}">
						<img src="/assets/media/logo.png" alt="" class="mb-16">
					</router-link>
					<p class="light-gray mb-xl-32 mb-lg-0 mb-32">
						Интернет-магазин электронной техники
					</p>
					<a href="tel:+78000000000" class="d-flex align-items-center gap-3">
						<div class="icon-box">
							<img src="/assets/media/icons/user-icon.png" alt="">
						</div>
						<div>
							<p class="light-gray mb-4p">
								Звоните 24/7
							</p>
							<h5 class="color-primary">+7 800 000 0000</h5>
						</div>
					</a>
				</div>
				<div class="footer-link-block">
					<h6 class="fw-600 mb-24">Категории</h6>
					<ul class="list-unstyled m-0">
						<li class="mb-8" v-for="cat in firstCategories" :key="cat.id">
							<router-link :to="{path: '/catalog', query: {categories: appModel.getAllChildCategoryIds(cat.id)}}" class="light-gray">{{cat.name}}</router-link>
						</li>
					</ul>
				</div>
				<div class="footer-link-block">
					<h6 class="fw-600 mb-24">Навигация</h6>
					<ul class="list-unstyled m-0">
						<li class="mb-8">
							<router-link :to="{path: '/'}" class="light-gray">Главная</router-link>
						</li>
						<li class="mb-8">
							<router-link :to="{path: '/about'}" class="light-gray">О магазине</router-link>
						</li>
						<li class="mb-8">
							<router-link :to="{path: '/catalog'}" class="light-gray">Каталог товаров</router-link>
						</li>
						<li class="mb-8">
							<router-link :to="{path: '/news'}" class="light-gray">Новости</router-link>
						</li>
						<li class="mb-8">
							<router-link :to="{path: '/contacts'}" class="light-gray">Контакты</router-link>
						</li>
					</ul>
				</div>
				<div class="footer-link-block">
					<h6 class="fw-600 mb-24">Профиль</h6>
					<ul class="list-unstyled m-0" v-if="authModel.isAuth()">
						<li class="mb-8">
							<router-link :to="{path: '/account'}" class="light-gray">Аккаунт</router-link>
						</li>
						<li class="mb-8">
							<router-link :to="{path: '/basket'}" class="light-gray">Корзина</router-link>
						</li>
						<li class="mb-8">
							<router-link :to="{path: '/wishlist'}" class="light-gray">Избранное</router-link>
						</li>
					</ul>
					<ul class="list-unstyled m-0" v-if="!authModel.isAuth()">
						<li class="mb-8">
							<router-link :to="{path: '/register'}" class="light-gray">Регистрация</router-link>
						</li>
						<li class="mb-8">
							<router-link :to="{path: '/login'}" class="light-gray">Авторизация</router-link>
						</li>
					</ul>
				</div>
				<div class="footer-link-block">
					<ul class="list-unstyled mb-16">
						<li class="mb-12 footer-link">
							<router-link :to="{path: '/contacts'}" class="d-flex align-items-center gap-2">
								<div class="img-box">
									<img src="/assets/media/icons/location.png" alt="">
								</div>
								<p class="light-gray">РК, г. Астана, пр. Республики, 58/15 · ул. Орлыкол, 14/3.</p>
							</router-link>
						</li>
						<li class="mb-12 footer-link">
							<a href="mailto:info@example.com" class="d-flex align-items-center gap-2">
								<div class="img-box">
									<img src="/assets/media/icons/mail-sm.png" alt="">
								</div>
								<p class="color-primary">intermagtech@mail.kz</p>
							</a>
						</li>
					</ul>
					<p class="fw-500 mb-16">Мы в соцсетях:</p>
					<ul class="list-unstyled social-link"> 
						<li>
							<a href="#">
								<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
									<path
										d="M12.5696 24.5995C12.4901 24.5995 12.4106 24.5995 12.3306 24.5992C10.4494 24.6038 8.71118 24.556 7.02075 24.4531C5.47095 24.3588 4.05627 23.8232 2.92944 22.9043C1.84216 22.0178 1.09967 20.819 0.722656 19.3417C0.394531 18.0555 0.377136 16.793 0.360474 15.5719C0.348389 14.6957 0.335937 13.6575 0.333374 12.6017C0.335937 11.5416 0.348389 10.5033 0.360474 9.62719C0.377136 8.40624 0.394531 7.14373 0.722656 5.85742C1.09967 4.38012 1.84216 3.18133 2.92944 2.29473C4.05627 1.37591 5.47095 0.840326 7.02093 0.746026C8.71136 0.643304 10.4499 0.595331 12.3352 0.599908C14.217 0.59588 15.9546 0.643304 17.6451 0.746026C19.1949 0.840326 20.6096 1.37591 21.7364 2.29473C22.8238 3.18133 23.5662 4.38012 23.9432 5.85742C24.2713 7.14355 24.2887 8.40624 24.3054 9.62719C24.3174 10.5033 24.3301 11.5416 24.3325 12.5973V12.6017C24.3301 13.6575 24.3174 14.6957 24.3054 15.5719C24.2887 16.7928 24.2715 18.0553 23.9432 19.3417C23.5662 20.819 22.8238 22.0178 21.7364 22.9043C20.6096 23.8232 19.1949 24.3588 17.6451 24.4531C16.0262 24.5516 14.3633 24.5995 12.5696 24.5995ZM12.3306 23.1127C14.1813 23.1171 15.8805 23.0702 17.5312 22.9699C18.7031 22.8987 20.0854 22.13 20.9178 21.4512C21.6872 20.8237 22.2171 19.958 22.4927 18.878C22.7658 17.8074 22.7816 16.6579 22.7968 15.5463C22.8087 14.676 22.8211 13.6451 22.8237 12.5995C22.8211 11.5538 22.8087 10.5231 22.7968 9.65282C22.7816 8.54119 22.7658 7.39166 22.4927 6.32086C22.2171 5.2409 21.6872 4.37518 20.9178 3.74767C20.0854 3.06909 18.7031 2.32292 17.5312 2.2517C15.8805 2.15117 14.1813 2.10485 12.335 2.10887C10.4847 2.10448 8.78534 2.15667 7.13464 2.2572C5.96277 2.32843 4.70864 2.83101 3.87624 3.50959C3.10683 4.1371 2.43443 5.2409 2.15885 6.32086C1.88566 7.39166 1.86991 8.54101 1.85472 9.65282C1.84281 10.5239 1.83036 11.5553 1.8278 12.6017C1.83036 13.6436 1.84281 14.6752 1.85472 15.5463C1.86991 16.6579 1.88566 17.8074 2.15885 18.878C2.43443 19.958 2.96434 20.8237 3.73374 21.4512C4.56614 22.1298 5.96277 22.8987 7.13464 22.9699C8.78534 23.0704 10.4851 23.1173 12.3306 23.1127ZM12.2859 18.4589C9.05523 18.4589 6.42657 15.8304 6.42657 12.5995C6.42657 9.36864 9.05523 6.74017 12.2859 6.74017C15.5168 6.74017 18.1453 9.36864 18.1453 12.5995C18.1453 15.8304 15.5168 18.4589 12.2859 18.4589ZM12.335 8.1045C9.70055 8.1045 7.84651 9.95854 7.84651 12.5973C7.84651 14.7942 9.50773 17.1126 12.3091 17.1126C14.5062 17.1126 16.7904 15.0312 16.7904 12.5973C16.7904 10.4004 15.1143 8.1045 12.335 8.1045ZM18.8016 4.86517C18.025 4.86517 17.3953 5.49468 17.3953 6.27142C17.3953 7.04815 18.025 7.67767 18.8016 7.67767C19.5783 7.67767 20.2078 7.04815 20.2078 6.27142C20.2078 5.49468 19.5783 4.86517 18.8016 4.86517Z"
										fill="#0C0C0D" />
								</svg>
							</a>
						</li>
						<li>
							<a href="#">
								<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
									<g clip-path="url(#clip0_5950_10656)">
										<path
											d="M17.9584 6.22461C18.3465 6.22461 18.6615 5.90961 18.6615 5.52148V1.30273C18.6615 0.914609 18.3465 0.599609 17.9584 0.599609H13.7396C11.0256 0.599609 8.81775 2.80742 8.81775 5.52148V9.03711H6.70837C6.32025 9.03711 6.00525 9.35211 6.00525 9.74023V13.959C6.00525 14.3471 6.32025 14.6621 6.70837 14.6621H8.81775V23.8965C8.81775 24.2846 9.13275 24.5996 9.52087 24.5996H13.7396C14.1277 24.5996 14.4427 24.2846 14.4427 23.8965V14.6621H17.2552C17.5988 14.6621 17.8923 14.4137 17.949 14.0748L18.6521 9.85602C18.6859 9.65211 18.6287 9.44352 18.4951 9.28555C18.3615 9.12805 18.1651 9.03711 17.9584 9.03711H14.4427V6.22461H17.9584ZM13.7396 10.4434H17.1282L16.6595 13.2559H13.7396C13.3515 13.2559 13.0365 13.5709 13.0365 13.959V23.1934H10.224V13.959C10.224 13.5709 9.909 13.2559 9.52087 13.2559H7.4115V10.4434H9.52087C9.909 10.4434 10.224 10.1284 10.224 9.74023V5.52148C10.224 3.5832 11.8013 2.00586 13.7396 2.00586H17.2552V4.81836H13.7396C13.3515 4.81836 13.0365 5.13336 13.0365 5.52148V9.74023C13.0365 10.1284 13.3515 10.4434 13.7396 10.4434Z"
											fill="#0C0C0D" />
									</g>
									<defs>
										<clipPath id="clip0_5950_10656">
											<rect width="24" height="24" fill="white" transform="translate(0.333374 0.599609)" />
										</clipPath>
									</defs>
								</svg>
							</a>
						</li>
						<li>
							<a href="#">
								<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
									<g clip-path="url(#clip0_5950_10659)">
										<path
											d="M14.5746 10.762L23.3171 0.599609H21.2454L13.6543 9.42345L7.5914 0.599609H0.598511L9.76688 13.9428L0.598511 24.5996H2.6703L10.6866 15.2813L17.0896 24.5996H24.0825L14.5741 10.762H14.5746ZM11.737 14.0604L10.8081 12.7317L3.4168 2.15922H6.59895L12.5638 10.6915L13.4928 12.0202L21.2464 23.1109H18.0642L11.737 14.0609V14.0604Z"
											fill="#0C0C0D" />
									</g>
									<defs>
										<clipPath id="clip0_5950_10659">
											<rect width="24" height="24" fill="white" transform="translate(0.333374 0.599609)" />
										</clipPath>
									</defs>
								</svg>
							</a>
						</li>
						<li>
							<a href="#">
								<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
									<g clip-path="url(#clip0_5950_10662)">
										<path
											d="M5.97705 8.13074H1.45837C1.07001 8.13074 0.755249 8.44568 0.755249 8.83386V23.8965C0.755249 24.2849 1.07001 24.5996 1.45837 24.5996H5.97705C6.36542 24.5996 6.68018 24.2849 6.68018 23.8965V8.83386C6.68018 8.44568 6.36542 8.13074 5.97705 8.13074ZM5.27393 23.1934H2.1615V9.53699H5.27393V23.1934Z"
											fill="#0C0C0D" />
										<path
											d="M3.7179 0.599609C2.08423 0.599609 0.755249 1.92859 0.755249 3.56189C0.755249 5.19556 2.08423 6.52435 3.7179 6.52435C5.35138 6.52435 6.68018 5.19537 6.68018 3.56189C6.68018 1.92859 5.35138 0.599609 3.7179 0.599609ZM3.7179 5.1181C2.85968 5.1181 2.1615 4.4201 2.1615 3.56189C2.1615 2.70386 2.85968 2.00586 3.7179 2.00586C4.57593 2.00586 5.27393 2.70386 5.27393 3.56189C5.27393 4.4201 4.57593 5.1181 3.7179 5.1181Z"
											fill="#0C0C0D" />
										<path
											d="M17.2745 8.03131C16.2057 8.03131 15.1523 8.28894 14.2089 8.77087C14.1769 8.41217 13.8757 8.13074 13.5085 8.13074H8.9895C8.60132 8.13074 8.28638 8.44568 8.28638 8.83386V23.8965C8.28638 24.2849 8.60132 24.5996 8.9895 24.5996H13.5085C13.8969 24.5996 14.2117 24.2849 14.2117 23.8965V15.6121C14.2117 14.5464 15.0789 13.6794 16.1445 13.6794C17.2102 13.6794 18.077 14.5464 18.077 15.6121V23.8965C18.077 24.2849 18.392 24.5996 18.7802 24.5996H23.299C23.6874 24.5996 24.0021 24.2849 24.0021 23.8965V14.759C24.0021 11.0493 20.9842 8.03131 17.2745 8.03131ZM22.5959 23.1934H19.4835V15.6121C19.4835 13.7709 17.9857 12.2731 16.1447 12.2731C14.3034 12.2731 12.8054 13.7709 12.8054 15.6121V23.1934H9.69281V9.53699H12.8054V10.0565C12.8054 10.3269 12.9605 10.5734 13.2044 10.6904C13.4481 10.8074 13.7374 10.774 13.9485 10.605C14.9007 9.84131 16.051 9.43756 17.2745 9.43756C20.2087 9.43756 22.5959 11.8247 22.5959 14.759V23.1934Z"
											fill="#0C0C0D" />
									</g>
									<defs>
										<clipPath id="clip0_5950_10662">
											<rect width="24" height="24" fill="white" transform="translate(0.333374 0.599609)" />
										</clipPath>
									</defs>
								</svg>
							</a>
						</li>
					</ul>
				</div>
			</div>
			<div class="hr-line"></div>
			<div class="footer-bottom-bar py-24">
				<p class="light-gray text-sm-left text-center">2025 &copy; Разработчик: Герман Кирилл, гр. ПО-43-21</p>
				<div class="payment-cards d-flex align-items-center gap-16">
					<p class="fw-500 light-gray d-sm-flex d-none">Способы оплаты:</p>
					<div class="card-block">
						<img src="/assets/media/icons/card-1.png" alt="">
					</div>
					<div class="card-block">
						<img src="/assets/media/icons/card-4.png" alt="">
					</div>
					<div class="card-block">
						<img src="/assets/media/icons/card-2.png" alt="">
					</div>
				</div>
			</div>
		</div>
	</footer>
	<!-- Benefits End -->
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	props: {
		footerClass: {
			type: [String, Array, Object],
		},
	},
	computed: {
		firstCategories() {
			return this.appModel.productsCategories.filter(cat => !cat.parent_id).slice(0, 5);
		}
	},
}
</script>